import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  type OnInit,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { CarouselCategoriesSkeletonComponent } from '@components/skeletons/carousel-categories-skeleton/carousel-categories-skeleton.component';
import { DEFAULT_PAGE_QUERY } from '@constants/settings.constant';
import { ImageFailedDirective } from '@directives/image-failed.directive';
import { ImagePipe } from '@pipes/image.pipe';
import { NutrishopService } from '@services/nutrishop.service';
import { SLIDE } from '@splidejs/splide';
import { map, tap } from 'rxjs';
import { CarouselWrapperComponent } from '../carousel-wrapper/carousel-wrapper.component';

@Component({
  selector: 'market-carousel-nutridayshop',
  standalone: true,
  imports: [
    CarouselCategoriesSkeletonComponent,
    RouterModule,
    AsyncPipe,
    ImagePipe,
    ImageFailedDirective,
    CarouselWrapperComponent,
  ],
  templateUrl: './carousel-nutridayshop.component.html',
  styleUrl: './carousel-nutridayshop.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselNutridayshopComponent implements OnInit {
  private nutriService = inject(NutrishopService);
  loading = signal(false);
  shops$ = this.nutriService
    .search({
      ...DEFAULT_PAGE_QUERY,
      keyword: '',
      size: 12,
    })
    .pipe(
      tap(() => this.loading.set(true)),
      map(x => x.data.items),
      tap(() => {
        this.loading.set(false);
      })
    );

  ngOnInit(): void {}

  get options() {
    return {
      type: SLIDE,
      perPage: 3.5,
      pagination: false,
      arrows: false,
      focus: 0,
    };
  }
}
